import { Accordion, AccordionDetails, IconButton, Typography } from '@mui/material';
import React from 'react';
import AccordionSummary from '@mui/material/AccordionSummary';
import { connect } from 'react-redux';
import { selectExcerpt } from '../../store/actions';
import LinkIcon from '@mui/icons-material/Link';
import { getExcerpt } from '../../inc/editorUtils';
import { getSelectionRange } from '../../inc/excerptUtils';
import { iExcerpt } from '../../types/types';

const mapStateToProps = (state) => ({
  selectedSublineData: state.mishnaView.selectedSublineData,
  selectedExcerpt: state.mishnaView.selectedExcerpt,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  selectExcerpt: (sublineData) => {
    dispatch(selectExcerpt(sublineData));
  },
});

interface Props {
  excerpt: iExcerpt;
  selectExcerpt: Function;
  selectedExcerpt: iExcerpt | null;
}
const ExcerptView = (props: Props) => {
  const { excerpt, selectExcerpt, selectedExcerpt } = props;
  
  // Derive expanded state directly from selectedExcerpt
  const isExpanded = selectedExcerpt?.key === excerpt.key;

  const handleClick = () => {
    if (!isExpanded) {
      selectExcerpt(excerpt);
    } else {
      selectExcerpt(null);
    }
  };

  let short = excerpt.short ? excerpt.short : getExcerpt(excerpt.editorStateFullQuote, 20);

  const selectionRange = getSelectionRange(excerpt);

  return (
    <>
      <Accordion square expanded={isExpanded} onClick={handleClick}>
        <AccordionSummary
          className={excerpt.link ? 'linked-excerpt' : ''}
          aria-controls="panel1d-content"
          id="panel1d-header"
          sx={{
            paddingTop: '0.3rem !important',
            paddingBottom: '0.3rem !important',
            fontSize: '1.05rem',
          }}>
          {excerpt.link ? (
            <IconButton
              component="div"
              role="button"
              tabIndex={0}
              aria-label="Open link in new tab"
              sx={{
                position: 'absolute',
                right: '0.5rem',
              }}
              onClick={(e) => {
                e.stopPropagation();
                window.open(excerpt.link, '_blank')?.focus();
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  e.stopPropagation();
                  window.open(excerpt.link, '_blank')?.focus();
                }
              }}
              size="small">
              <LinkIcon />
            </IconButton>
          ) : null}
          <div>
            <Typography component="span">[{selectionRange}] </Typography>
            <Typography style={{ fontWeight: 'bold' }} component="span">
              {excerpt.source?.title}{' '}
            </Typography>
            <Typography component={excerpt.sourceLocation?.includes('\n') ? 'p' : 'span'}>
              {excerpt.sourceLocation}
            </Typography>
          </div>
        </AccordionSummary>
        <AccordionDetails sx={{ 
          paddingTop: '0 !important', 
          paddingBottom: '0 !important',
          marginTop: '-1.5rem',
          '& p': { margin: 0 },
        }}>
          <div dangerouslySetInnerHTML={{ __html: short }}></div>
        </AccordionDetails>
      </Accordion>
    </>
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(ExcerptView);
